import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/design/components/atoms/data-table-body/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe805bae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe805bae', __exports__)) {
    api.reload('fe805bae', __exports__)
  }
  
}


export default __exports__